import CheckmateSelect from '../CheckmateSelect';
import CheckmateSelectHelper from '../../../utilities/CheckmateSelectHelper';
import Common from '../../../stores/Common';
import { FileIcon } from './FileIcon';
import { IDocumentModel } from '../../../interfaces/ICase';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { IValidation } from '../../../interfaces/IError';
import { IconButton } from '../../../shared/buttons/IconButton';
import { Stack } from 'react-bootstrap';
import { useDocumentCategoryTypes } from '../../../shared/react-query-hooks/useDocumentCategoryTypes';
import { useState } from 'react';

export function DocumentMeta(props: {
    disabled?: boolean;
    document: IDocumentModel;
    getDocumentNameExists: (current: string) => boolean;
    entityTypeId: number;
    onCategoriesChange: (documentGuid: string, opts: IMultiSelectOption[]) => void;
    onRemoveClick: (documentGuid: string) => void;
    onFileNameChange: (documentGuid: string, value: string) => void;
    validation?: IValidation;
}) {
    const { document } = props;

    const categoryDocumentTypes = useDocumentCategoryTypes(props.entityTypeId);
    const showDocumentCategory = (categoryDocumentTypes?.data?.length ?? 0) > 0;
    const categoryDocumentTypeOptions = CheckmateSelectHelper.getLookupOptions(
        categoryDocumentTypes.data ?? [],
        false
    );

    const [localFileName, setLocalFileName] = useState<string>(document.fileName ?? '');

    const handleFileNameBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!document.guid) {
            return;
        }
        props.onFileNameChange(document.guid, e.target.value);
    };

    const onLocalFileNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLocalFileName(e.target.value);
    };

    const handleCategoriesChange = (opts: IMultiSelectOption[]) => {
        if (!document.guid) {
            return;
        }
        props.onCategoriesChange(document.guid, opts);
    };

    return (
        <li
            key={document.fileName}
            style={{
                background: '#f6f6f6',
                padding: '.5em 1em',
                marginTop: '1em',
            }}
        >
            <Stack direction="horizontal" gap={3} style={{ alignItems: 'start' }}>
                <div className="pt-2">
                    <FileIcon mimeType={document.file?.type} />
                </div>
                <Stack gap={2}>
                    <Stack
                        direction="horizontal"
                        gap={2}
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '100%',
                        }}
                    >
                        <input
                            disabled={props.disabled}
                            type="text"
                            className="form-control w-100"
                            value={localFileName}
                            placeholder="File Name"
                            onChange={onLocalFileNameChange}
                            onBlur={handleFileNameBlur}
                        />
                        <div
                            className="text-gray font-size-0_9"
                            style={{ flexBasis: 100, textAlign: 'left' }}
                        >
                            {document.file?.size ? Common.formatBytes(document.file?.size) : null}
                        </div>
                    </Stack>
                    {showDocumentCategory && (
                        <div>
                            <CheckmateSelect
                                isDisabled={props.disabled}
                                isMulti={true}
                                onChange={handleCategoriesChange}
                                options={categoryDocumentTypeOptions}
                                value={categoryDocumentTypeOptions.filter((cdt) =>
                                    document.documentCategoryTypeIds?.includes(cdt.id)
                                )}
                                placeholder="Category"
                            />
                        </div>
                    )}
                </Stack>
                <IconButton
                    buttonCssClass="btn-no-bg"
                    buttonStyle={{ marginRight: '-1em', marginTop: '0.5em' }}
                    icon="fal fa-lg fa-times"
                    onClick={() => props.onRemoveClick(document.guid!)}
                />
            </Stack>
            <div style={{ fontSize: '0.9em', marginTop: 3, paddingLeft: 30 }}>
                {(localFileName?.trim().length ?? 0) === 0 && props.validation?.filename && (
                    <div className="text-danger">{props.validation?.filename}</div>
                )}
            </div>
            <div style={{ fontSize: '0.9em', marginTop: 3, paddingLeft: 30 }}>
                {props.validation?.uniqueFilename && (
                    <div className="text-danger">{props.validation?.uniqueFilename}</div>
                )}
            </div>
            <Stack gap={2}>
                {props.getDocumentNameExists(localFileName) && (
                    <Stack
                        direction="horizontal"
                        gap={1}
                        style={{ opacity: 0.8, fontSize: '0.8em', marginTop: 10, paddingLeft: 30 }}
                    >
                        <i className="fal fa-warning" />{' '}
                        <span className="text-blue">
                            A file with the same name already exists. By default, a new version of
                            the file will be saved along with all older versions.
                        </span>
                    </Stack>
                )}
            </Stack>
            {props.validation?.file && <div className="text-danger">{props.validation?.file}</div>}
        </li>
    );
}
